/**
 * Decodifica il JWT in localStorage e restituisce i dati utente corrente.
 * Non fa chiamate API — legge direttamente il payload del token.
 */
const useCurrentUser = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return {
            id:    payload.id,
            email: payload.email,
            ruolo: payload.ruolo || 'admin',
        };
    } catch {
        return null;
    }
};

export const getCurrentUser = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return {
            id: payload.id,
            email: payload.email,
            ruolo: payload.ruolo || 'admin',
            nome: payload.nome || '',
            cognome: payload.cognome || '',
        };
    } catch {
        return null;
    }
};

export const getRuolo = () => getCurrentUser()?.ruolo || 'admin';

export const hasRuolo = (...ruoli) => ruoli.includes(getRuolo());

export default useCurrentUser;
